<template>
  <UApp>
    <UOverlayProvider>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </UOverlayProvider>
  </UApp>
</template>

<script setup>
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Retailer Locator` : 'Retailer Locator';
  }
})
</script>